import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

// See useDccBridgeAccess: private mode shares the same server-resolved entitlement, enforced in
// Api::Internal::Generator::RunsController.
function usePrivateModeAccess() {
  const premiumFeatures = useThreeDStudioStore((state) => state.subscription.premiumFeatures)
  return premiumFeatures === true
}

export default usePrivateModeAccess
